//Login Page Important Message//
export const IMPORTANT_MESSAGE = "Important: EDC will be accessible at ";
export const HREF_LINK= "https://edc.nxtrial.com/"
export const IMPORTANT_DATE = " from 22nd December 2025."
export const EMAIL_DOES_NOT_EXIST_MSG = "Email does not exists";
export const CAPTCHA_MSG = "Please enter a valid captcha";
export const CAPTCHA_IS_REQUIRED_MSG = "Please enter a captcha";

// Auditlog messages
export const USER_LOG = "User log";
export const DATA_NOT_AVAILABLE_MSG = "Data not available";
export const REPORT_GENERATION_MSG = ". Please wait for a while to generate the report.";
export const STUDY_LOG = "Study Log";
export const MASTER_LOGS = "Master Logs";

export const USER_NAME_MAX_LENGTH = 50;
export const USER_NAME_MAX_LENGTH_MSG = "Maximum 50 characters are allowed";

export const PLATFORM_SELECTION_ERROR_MSG = "Please select platform";
export const STUDY_SELECTION_ERROR_MSG = "Please select study";
export const ROLE_SELECTION_ERROR_MSG = "Please select role";

//Change Password Message
export const CURRENT_PASSWORD_NULL_MSG = "Enter old password";
export const NEW_PASSWORD_NULL_MSG = "Enter new password";
export const CONFIRM_PASSWORD_NULL_MSG = "Enter confirm new password";
export const PASSWORD_NOT_MATCH_MSG = "New password & confirm password didn't match.";
export const USERID_NULL_MSG = "User Id is null.";
export const PASSWORD_SPECIAL_CHAR_ERROR_MSG = "Password should include combination of upper and lowe case, number and special characters"
export const PASSWORD_REQUIRED_MSG = "Password is required";
export const PASSWORD_LENGTH_ERROR_MSG = "Password must be at least 8 characters"

export const USER_NAME_REQUIRED_MSG = "Please enter your username";
export const USER_NAME_VALID_MSG = "Please enter a valid username";
export const PASSWORD_IS_REQUIRED_MSG = "Please enter your password";
export const PASSWORD_VALID_MSG = "Please enter a valid password";

export const INVALID_CREDENTIALS_MSG = "Invalid username or password";
export const UNABLE_TO_CONNECT_MSG = "Unable to connect, please try again later";
export const LOGIN_FAILED_MSG = "Login Failed: Unexpected error.";

export const ENTER_VALID_EMAIL_ADDRESS = 'Please enter a valid email address';
export const ENTER_YOUR_EMAIL_ADDRESS = 'Please enter your email address';

export const SESSION_EXPIRED_MSG = 'Your session has expired. Please login again.';

export const FAILED_TO_LOAD_ROLES_STUDIES_MSG = 'Failed to load roles and studies';

export const ROLE_LOAD_FAILED = 'Failed to load roles';
export const ROLE_CREATED_SUCCESS = 'Role created successfully';
export const ROLE_CREATE_FAILED = 'Failed to create role';
export const ROLE_UPDATED_SUCCESS = 'Role updated successfully';
export const ROLE_UPDATE_FAILED = 'Failed to update role';
export const ROLE_DELETED_SUCCESS = 'Role deleted successfully';
export const ROLE_DELETE_FAILED = 'Failed to delete role';

// Platform Entity Messages
export const PLATFORM_ENTITY_LOAD_FAILED = 'Failed to load entities';
export const PLATFORM_ENTITY_CREATED_SUCCESS = 'Entity created successfully';
export const PLATFORM_ENTITY_CREATE_FAILED = 'Failed to create entity';
export const PLATFORM_ENTITY_UPDATED_SUCCESS = 'Entity updated successfully';
export const PLATFORM_ENTITY_UPDATE_FAILED = 'Failed to update entity';
export const PLATFORM_ENTITY_DELETED_SUCCESS = 'Entity deleted successfully';
export const PLATFORM_ENTITY_DELETE_FAILED = 'Failed to delete entity';
export const PLATFORM_ENTITY_NAME_REQUIRED = 'Entity name is required';
export const PLATFORM_ENTITY_CODE_REQUIRED = 'Entity code is required';
export const PLATFORM_ENTITY_PLATFORM_REQUIRED = 'At least one platform must be selected';

// Account Relation Messages
export const ACCOUNT_RELATION_CREATED_SUCCESS = 'Account relation created successfully';
export const ACCOUNT_RELATION_CREATE_FAILED = 'Failed to create account relation';
export const ACCOUNT_RELATION_DELETED_SUCCESS = 'Account relation deleted successfully';
export const ACCOUNT_RELATION_DELETE_FAILED = 'Failed to delete account relation';

// Platform Window Messages
export const PLATFORM_WINDOW_LOAD_FAILED = 'Failed to load windows';
export const PLATFORM_WINDOW_CREATED_SUCCESS = 'Window created successfully';
export const PLATFORM_WINDOW_CREATE_FAILED = 'Failed to create window';
export const PLATFORM_WINDOW_UPDATED_SUCCESS = 'Window updated successfully';
export const PLATFORM_WINDOW_UPDATE_FAILED = 'Failed to update window';
export const PLATFORM_WINDOW_DELETED_SUCCESS = 'Window deleted successfully';
export const PLATFORM_WINDOW_DELETE_FAILED = 'Failed to delete window';
export const PLATFORM_WINDOW_NAME_REQUIRED = 'Window name is required';
export const PLATFORM_WINDOW_PLATFORM_REQUIRED = 'Platform selection is required';
export const PLATFORM_WINDOW_MODULE_REQUIRED = 'Module selection is required';

// Platform Action Messages
export const ACTION_LOAD_FAILED = 'Failed to load actions';
export const ACTION_CREATED_SUCCESS = 'Action created successfully';
export const ACTION_CREATE_FAILED = 'Failed to create action';
export const ACTION_UPDATED_SUCCESS = 'Action updated successfully';
export const ACTION_UPDATE_FAILED = 'Failed to update action';
export const ACTION_DELETED_SUCCESS = 'Action deleted successfully';
export const ACTION_DELETE_FAILED = 'Failed to delete action';
export const ACTION_NAME_REQUIRED = 'Action name is required';
export const ACTION_CODE_REQUIRED = 'Action code is required';
export const ACTION_PLATFORM_REQUIRED = 'Platform must be selected';

// Platform Report Messages
export const REPORT_LOAD_FAILED = 'Failed to load reports';
export const REPORT_CREATED_SUCCESS = 'Report created successfully';
export const REPORT_CREATE_FAILED = 'Failed to create report';
export const REPORT_UPDATED_SUCCESS = 'Report updated successfully';
export const REPORT_UPDATE_FAILED = 'Failed to update report';
export const REPORT_DELETED_SUCCESS = 'Report deleted successfully';
export const REPORT_DELETE_FAILED = 'Failed to delete report';
export const REPORT_NAME_REQUIRED = 'Report name is required';
export const REPORT_CODE_REQUIRED = 'Report code is required';
export const REPORT_PLATFORM_REQUIRED = 'Platform must be selected';

// Permission Access Messages
export const WINDOW_ACCESS_LOAD_FAILED = 'Failed to load window access data';
export const WINDOW_ACCESS_SAVED_SUCCESS = 'Window access permissions saved successfully';
export const WINDOW_ACCESS_SAVE_FAILED = 'Failed to save window access permissions';
export const REPORT_ACCESS_LOAD_FAILED = 'Failed to load report access data';
export const REPORT_ACCESS_SAVED_SUCCESS = 'Report access permissions saved successfully';
export const REPORT_ACCESS_SAVE_FAILED = 'Failed to save report access permissions';
export const ACTION_ACCESS_LOAD_FAILED = 'Failed to load action access data';
export const ROLE_REQUIRED_MSG = 'Please select a role first';
export const NO_DATA_AVAILABLE_MSG = 'No data available to save';
export const PERMISSIONS_RESET_SUCCESS = 'Permissions have been reset to their original values';

// Platform Module Messages
export const PLATFORM_MODULE_LOAD_FAILED = 'Failed to load modules';
export const PLATFORM_MODULE_CREATED_SUCCESS = 'Module created successfully';
export const PLATFORM_MODULE_CREATE_FAILED = 'Failed to create module';
export const PLATFORM_MODULE_UPDATED_SUCCESS = 'Module updated successfully';
export const PLATFORM_MODULE_UPDATE_FAILED = 'Failed to update module';
export const PLATFORM_MODULE_DELETED_SUCCESS = 'Module deleted successfully';
export const PLATFORM_MODULE_DELETE_FAILED = 'Failed to delete module';
export const PLATFORM_MODULE_NAME_REQUIRED = 'Module name is required';

// Unsaved Changes Messages
export const UNSAVED_CHANGES_CONFIRMATION = 'Unsaved Changes';
export const UNSAVED_CHANGES_MESSAGE = 'You have unsaved changes. Are you sure you want to leave?';
export const CANCEL = 'Cancel';
export const YES = 'Yes';
export const SESSION_LOGOUT = 'Logged out successfully due to inactivity';

// Excel

export const AUDITLOG_EXPORT_SUCCESSFULLY = "Audit log export successfully";